import { useMenuData } from "../offline/menuData"
import { syncChip } from "../models/syncStatus"
import "./SyncStatusChip.css"

// Derived from the sync state, never switched; tapping opens the Offline Data sheet.
export default function SyncStatusChip({ onClick }) {
  const { sync, isOnline, now } = useMenuData()
  const chip = syncChip(sync, { isOnline, now })

  return (
    <button
      type="button"
      className={`sync-chip sync-chip--${chip.tone} t-c12`}
      aria-label={`Menu ${chip.label}. Open offline data`}
      onClick={onClick}
    >
      <span className="sync-chip__dot" aria-hidden="true" />
      <span className="sync-chip__label">{chip.label}</span>
    </button>
  )
}
